module.exports = __webpack_public_path__ + "img/cmnd-front-2.d66afe83.png";